import { render, staticRenderFns } from "./bookPerBatchModal.vue?vue&type=template&id=2193a723&scoped=true&"
import script from "./bookPerBatchModal.vue?vue&type=script&lang=js&"
export * from "./bookPerBatchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2193a723",
  null
  
)

export default component.exports